<app-loading *ngIf="cargando"></app-loading>
<div class="grid" *ngIf="!cargando">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="grid" >
      <div class="col-12 md:col-12 lg:col-12"
           *ngIf="!segmento.indicadorHabilitado
           && segIngresos.length<1 || (!segmento.indicadorHabilitado )
          ">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'SEGMENTOSINGRESOS.LBL_NOMBRERANGO' | translate }}</label>
                <input type="text" pInputText id="idNombreRango"
                       name="nomNombreRango"
                       autocomplete="off"
                       formControlName="nombreRango" capitalize-reactive
                       [maxlength]="50">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreRango.invalid">
                  {{ 'SEGMENTOSINGRESOS.LBL_NOMBRERANGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'SEGMENTOSINGRESOS.LBL_RANGODESDE' | translate }}</label>
                <input type="text" pInputText id="idDesde"
                       name="nomDesde"
                       autocomplete="off"
                       formControlName="rangoDesde" numero-decimal-reactive
                       (blur)="validarValor($event, true)"
                       [decimales]="6" [minimo]="0" [entero]="7">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoDesde.invalid">
                  {{ 'SEGMENTOSINGRESOS.LBL_RANGODESDE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="!rangoDesdeValido">
                  {{ 'SEGMENTOSINGRESOS.LBL_RANGODESDESUPERA' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'SEGMENTOSINGRESOS.LBL_RANGOHASTA' | translate }}</label>
                <input type="text" pInputText id="idHasta"
                       name="nomHasta"
                       autocomplete="off"
                       formControlName="rangoHasta" numero-decimal-reactive
                       (blur)="validarValor($event, false)"
                       [decimales]="6" [minimo]="0" [entero]="7"
                      >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoHasta.invalid">
                  {{ 'SEGMENTOSINGRESOS.LBL_RANGOHASTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && !rangoInvalido">
                  {{ 'SEGMENTOSACTIVOS.MSG_ERRORRANGO' | translate }}
                </div>

              </div>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <button icon="fa fa-plus" *ngIf="!edit"
                        label="{{'BTN_AGREGAR' | translate }}"
                        type="submit"
                        pButton></button>
                <button icon="fa fa-plus" *ngIf="edit"
                        label="{{'BTN_EDITAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carSegmentoIngreso" #dt
                 [value]="segIngresos" selectionMode="single" dataKey="idSegmentoIngreso"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreRango}}</td>
              <td>{{row.rangoDesde}}</td>
              <td>{{row.rangoHasta}}</td>
              <td class="text-center" *ngIf="!detalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)" *ngIf="!segmento.indicadorHabilitado"></button>

                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_DESHABILITAR' | translate}}" pButton
                          (click)="disable(row)" *ngIf="!segmento.indicadorHabilitado"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 md:col-12 lg:col-12" *ngIf="segmentoTemp!==undefined && segmentoTemp.segmentosIngresos !== null
           && segmentoTemp.segmentosIngresos.length>0">
        <hr>
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnasH"
                   [value]="segmentoTemp.segmentosIngresos" selectionMode="single" dataKey="idSegmentoIngreso"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombreRango}}</td>
                <td>{{row.rangoDesde}}</td>
                <td>{{row.rangoHasta}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="ingreso">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
